export class RefreshButtonComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-refresh-button/src/refresh_button/refresh_button.html';
  public controller: any = RefreshButtonController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    action: '&',
    isRefreshing: '<',
    announceText: '@',
    labelText: '@'
  };
}

declare var HIP: {
  fn: {
    announce: (text: string) => void;
  };
};

export class RefreshButtonController {
  private action: () => void;
  private isRefreshing: boolean;
  public announceText: string;
  public labelText: string;

  getIconType(): string {
    return this.isRefreshing ? 'sync' : 'refresh';
  }

  refreshAction() {
    if (this.action) {
      this.action();
    }

    if (this.announceText) {
      HIP.fn.announce(this.announceText);
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-refresh-button/src/refresh_button/refresh_button.ts